module.exports = __webpack_public_path__ + "img/pie-chart.3dcd7e6c.svg";